import "nodelist-foreach-polyfill";

const helpMessageQuestions = document.querySelectorAll(".js-helpMessage-question");

helpMessageQuestions.forEach((question) => {
  const helpContent = question.parentNode?.querySelector(".js-helpMessage-content");

  question.addEventListener("mouseover", () => {
    question.classList.remove("disabled");
    helpContent?.classList.remove("disabled");
  });

  question.addEventListener("mouseleave", () => {
    question.classList.add("disabled");
    helpContent?.classList.add("disabled");
  });
});
